const ageGateClosed = new Event("age-gate-closed");

function fireAgeGateClosed() {
  window.dispatchEvent(ageGateClosed);
}

if (window.self === window.top) {
  let ageCookie = getCookie("ageGate");

  if (ageCookie != "pass") {
    ageGateShow();
    if (ageCookie == "fail") {
      ageGateLock();
    }
  } else {
    setTimeout(fireAgeGateClosed, 2000);
  }
}

function ageGateShow() {
  document.body.classList.add("overflow-hidden");
  document.getElementById("age-gate").classList.add("active");
}

function ageGateHide() {
  document.body.classList.remove("overflow-hidden");
  document.getElementById("age-gate").classList.remove("active");
  fireAgeGateClosed();
}

function ageGateLock() {
  document.getElementById("age-gate").classList.add("locked");
}

function ageGatePass() {
  document.cookie = "ageGate=pass; path=/; max-age=" + 30 * 24 * 60 * 60;
  ageGateHide();
}

function ageGateFail() {
  document.cookie = "ageGate=fail; path=/";
  ageGateLock();
}

function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
